import { CSSObjectWithLabel } from 'react-select'

export const UPDATE = 'Update'
export const CANCEL = 'Cancel'
export const DELETE = 'DELETE'
export const SUSPEND = 'SUSPEND'
export const ACTIVATE = 'ACTIVATE'
export const TESTER = 'TESTER'
export const DOWNLOAD = 'download'
export const ONE_ITEM = 1
export const NO_RECORDS_FOUND_TEXT = 'No records found'
export const DEFAULT_LANG = 'English'
export const DEBOUNCE_DELAY = 300
export const COMMON_DATE_FORMAT = 'MM-DD-YYYY | HH:mm:ss'
export const DATE_FORMAT_DETAIL_VIEW = 'MM-DD-YYYY | HH:mm'
export const DATE_TIME_PICKER_INTERVAL = 5
export const COMMON_DATE_TIME_FORMAT = 'MMMM d, yyyy h:mm aa'
export const MONTH_ONLY_DATE_FORMAT = 'MMMM YYYY'
export const COMMON_DATE_TIME_UTC_FORMAT = 'YYYY-MM-DD HH:mm:ss.SSS'
export const DATE_RANGE_FILTER_KEY = 'dateRange'
export const DASH = '-'
export const BACK = '<'
export const POINTS = 'Points'
export const AVAILABLE = 'Available'
export const REDEEMED = 'Redeemed'
export const REFUNDED = 'Refunded'
export const TIMES = 'times'
export const SECONDS = 'seconds'
export const DAYS = 'days'
export const DESCRIPTION = 'Description'
export const TITLE = 'Title'
export const INSTRUCTION = 'Instructions'
export const COUPONS = 'Coupons'
export const FAVOURITE_COUNT = 'Favourite Count'
export const NAME = 'Name'
export const SUB_TITLE = 'Sub-Title'
export const LISTED_POINTS = 'Listed Points'
export const REAL_POINTS = 'Real Points'
export const TARGET_GROUP_LIST_ITEM_HEIGHT = 35
export const COMMON_IMG_DIMENSION = 35
export const INCLUDED = 'included'
export const EXCLUDED = 'excluded'
export const USERS = 'users'
export const ADD_ALL_USERS = 'Add All Users'
export const CTA = 'CTA'
export const SUB_HEADER1 = 'Sub-header 1'
export const SUB_HEADER2 = 'Sub-header 2'
export const UI_POSITION = 'UI Position'
export const BADGE = 'Badge'
export const CHARACTERS = 'Characters'
export const CAMPAIGNS = 'Campaigns'
export const OFFERS = 'Offers'
export const OFFER = 'Offer'
export const PROVIDERS = 'Providers'
export const UPDATES = 'Update Cards'
export const CAMPAIGN_CATEGORIES = 'Campaign Categories'
export const OFFERS_CATEGORIES = 'Offers Categories'
export const CREATE_DATE = 'Created Date'
export const SEGMENT_SELECTED = 'Segment Selected'
export const CAMPAIGNS_INCLUDED = 'Campaigns Included'
export const OFFERS_INCLUDED = 'Offers Included'
export const TOTAL_TRIP = 'Total Trips'
export const NO_FILE = 'No File Chosen'
export const REQUIRED = 'Required'
export const MAX_CACHE_AGE = 60 * 60 * 24 * 30
export const ID = 'ID'
export const TAB = 'tab'
export const HASHTAG = '#'
export const YES = 'Yes'
export const NO = 'No'
export const CONNECT_TITLE = 'Connect Title'
export const CONNECT_DESCRIPTION = 'Connect Description'
export const IMAGE = 'Image'
export const LEFT_PANNEL_IMG_DIMENSION_WIDTH = 100
export const LEFT_PANNEL_IMG_DIMENSION_HEIGHT = 50
export const INITIAL_PAGE = 0
export const COMMON_ACCEPTED_IMG_TYPES = '.png, .jpg, .ico, .jpeg, .webp'
export const BOLD_WORDS = 'font-bold'
export const ITEM_REMOVAL_COUNT = 1
export const ITEM_INSERTION_INDEX = 0
export const ON_DRAG_INCREMENT = 1
export const NO_RECORDS_NUMBER = 0
export const CSV_EXTENSION = 'csv'
export const PERIOD_DATE_FORMAT = 'MMM DD, YYYY'
export const PERCENTS = '%'
export const UPDATE_LABEL = 'Update'
export const DISCARD_LABEL = 'Discard'
export const PREVIEW_LABEL = 'Preview'
export const PREVIOUS_STEP_LABEL = 'Previous Step'
export const LANGUAGE_SELECT_LABEL = 'Language Selected'
export const AUTO_TRANSLATION_LABEL = 'Auto Translation'
export const TRANSLATIONS = 'translations'
export const TRANSLATIONS_SELECT = 'translations-select'
export const SELECTION_INITIAL_INDEX = 0
export const ENTER = 'Enter'
export const UNIT = 'Unit'
export const SELECT = 'Select'
export const SWAP_ICON_TIME = 300
export const CODE_SHOW_MAX_CHARACTERS = 20
export const PERIOD_EXAMPLE = 'e.g: 3 days or 6 months or 2 years'
export const SCHEDULE_EXAMPLE = 'e.g: 0 0 * * *'
export const INACTIVE_EVENT_CATEGORY_EXAMPLE = 'e.g: Home'
export const INACTIVE_EVENT_ACTION_EXAMPLE = 'e.g: Rewards Opened'
export const COMMA = ','

export enum Languages {
  en = 'English',
  bn = 'Bengali',
  ko = 'Korean',
  es = 'Spanish',
  vi = 'Vietnamese',
  ar = 'Urdu',
  ru = 'Russian',
  cn = 'Chinese'
}

export const COMMON_STATUSES = {
  LIVE: 'Live',
  HIDDEN: 'Hidden',
  EXPIRED: 'Expired',
  DRAFT: 'Draft',
  DISABLED: 'Disabled'
}
export const PAGINATION_CONSTANTS = {
  DEFAULT_PAGE_SIZE: 15,
  DEFAULT_CURRENT_PAGE: 1,
  NON_EXISTENT_PAGE: 0
}

export const COMMON_TARGET_GROUPS_COLUMNS = [
  'ID',
  'Added Date',
  'Name',
  'Users Included',
  ''
]

export const ADD_SEGMENT_DIALOG_TEXT = {
  INCLUDED:
    'Select the segment to be included on the list of Segments that can see this',
  EXCLUDED: 'Select a segment to be excluded from seeing this'
}

export const REORDER_UI_POSITION_DIALOG = {
  DEFAULT_POSITION: 1,
  INDEX_BASED_POSITION_INCREMENT: 2,
  ITEM_REMOVAL_COUNT: 1,
  ITEM_INSERTION_INDEX: 0,
  ON_DRAG_INCREMENT: 1
}
export const SEGMENTS_TYPES = {
  AVAILABLE_SEGMENTS: 'availableSegments',
  EXCLUDED_SEGMENTS: 'excludeSegments'
}

export const POP_UP_TYPES = {
  CREATE: 'create',
  UPDATE: 'update',
  DISCARD: 'discard',
  CANCEL: 'cancel',
  DUPLICATE: 'duplicate',
  DRAFT: 'draft',
  DELETE: 'delete'
} as const

export const PREDEFINED_BADGE_ICON_LIST = [
  'AcademicCapIcon',
  'AdjustmentsHorizontalIcon',
  'AdjustmentsVerticalIcon',
  'ArchiveBoxArrowDownIcon',
  'ArchiveBoxXMarkIcon',
  'ArchiveBoxIcon',
  'ArrowDownCircleIcon',
  'ArrowDownLeftIcon',
  'ArrowDownOnSquareStackIcon',
  'ArrowDownOnSquareIcon',
  'ArrowDownRightIcon',
  'ArrowDownTrayIcon',
  'ArrowDownIcon',
  'ArrowLeftCircleIcon',
  'ArrowLeftOnRectangleIcon',
  'ArrowLeftIcon',
  'ArrowLongDownIcon',
  'ArrowLongLeftIcon',
  'ArrowLongRightIcon',
  'ArrowLongUpIcon',
  'ArrowPathRoundedSquareIcon',
  'ArrowPathIcon',
  'ArrowRightCircleIcon',
  'ArrowRightOnRectangleIcon',
  'ArrowRightIcon',
  'ArrowSmallDownIcon',
  'ArrowSmallLeftIcon',
  'ArrowSmallRightIcon',
  'ArrowSmallUpIcon',
  'ArrowTopRightOnSquareIcon',
  'ArrowTrendingDownIcon',
  'ArrowTrendingUpIcon',
  'ArrowUpCircleIcon',
  'ArrowUpLeftIcon',
  'ArrowUpOnSquareStackIcon',
  'ArrowUpOnSquareIcon',
  'ArrowUpRightIcon',
  'ArrowUpTrayIcon',
  'ArrowUpIcon',
  'ArrowUturnDownIcon',
  'ArrowUturnLeftIcon',
  'ArrowUturnRightIcon',
  'ArrowUturnUpIcon',
  'ArrowsPointingInIcon',
  'ArrowsPointingOutIcon',
  'ArrowsRightLeftIcon',
  'ArrowsUpDownIcon',
  'AtSymbolIcon',
  'BackspaceIcon',
  'BackwardIcon',
  'BanknotesIcon',
  'Bars2Icon',
  'Bars3BottomLeftIcon',
  'Bars3BottomRightIcon',
  'Bars3CenterLeftIcon',
  'Bars3Icon',
  'Bars4Icon',
  'BarsArrowDownIcon',
  'BarsArrowUpIcon',
  'Battery0Icon',
  'Battery100Icon',
  'Battery50Icon',
  'BeakerIcon',
  'BellAlertIcon',
  'BellSlashIcon',
  'BellSnoozeIcon',
  'BellIcon',
  'BoltSlashIcon',
  'BoltIcon',
  'BookOpenIcon',
  'BookmarkSlashIcon',
  'BookmarkSquareIcon',
  'BookmarkIcon',
  'BriefcaseIcon',
  'BugAntIcon',
  'BuildingLibraryIcon',
  'BuildingOffice2Icon',
  'BuildingOfficeIcon',
  'BuildingStorefrontIcon',
  'CakeIcon',
  'CalculatorIcon',
  'CalendarDaysIcon',
  'CalendarIcon',
  'CameraIcon',
  'ChartBarSquareIcon',
  'ChartBarIcon',
  'ChartPieIcon',
  'ChatBubbleBottomCenterTextIcon',
  'ChatBubbleBottomCenterIcon',
  'ChatBubbleLeftEllipsisIcon',
  'ChatBubbleLeftRightIcon',
  'ChatBubbleLeftIcon',
  'ChatBubbleOvalLeftEllipsisIcon',
  'ChatBubbleOvalLeftIcon',
  'CheckBadgeIcon',
  'CheckCircleIcon',
  'CheckIcon',
  'ChevronDoubleDownIcon',
  'ChevronDoubleLeftIcon',
  'ChevronDoubleRightIcon',
  'ChevronDoubleUpIcon',
  'ChevronDownIcon',
  'ChevronLeftIcon',
  'ChevronRightIcon',
  'ChevronUpDownIcon',
  'ChevronUpIcon',
  'CircleStackIcon',
  'ClipboardDocumentCheckIcon',
  'ClipboardDocumentListIcon',
  'ClipboardDocumentIcon',
  'ClipboardIcon',
  'ClockIcon',
  'CloudArrowDownIcon',
  'CloudArrowUpIcon',
  'CloudIcon',
  'CodeBracketSquareIcon',
  'CodeBracketIcon',
  'Cog6ToothIcon',
  'Cog8ToothIcon',
  'CogIcon',
  'CommandLineIcon',
  'ComputerDesktopIcon',
  'CpuChipIcon',
  'CreditCardIcon',
  'CubeTransparentIcon',
  'CubeIcon',
  'CurrencyBangladeshiIcon',
  'CurrencyDollarIcon',
  'CurrencyEuroIcon',
  'CurrencyPoundIcon',
  'CurrencyRupeeIcon',
  'CurrencyYenIcon',
  'CursorArrowRaysIcon',
  'CursorArrowRippleIcon',
  'DevicePhoneMobileIcon',
  'DeviceTabletIcon',
  'DocumentArrowDownIcon',
  'DocumentArrowUpIcon',
  'DocumentChartBarIcon',
  'DocumentCheckIcon',
  'DocumentDuplicateIcon',
  'DocumentMagnifyingGlassIcon',
  'DocumentMinusIcon',
  'DocumentPlusIcon',
  'DocumentTextIcon',
  'DocumentIcon',
  'EllipsisHorizontalCircleIcon',
  'EllipsisHorizontalIcon',
  'EllipsisVerticalIcon',
  'EnvelopeOpenIcon',
  'EnvelopeIcon',
  'ExclamationCircleIcon',
  'ExclamationTriangleIcon',
  'EyeDropperIcon',
  'EyeSlashIcon',
  'EyeIcon',
  'FaceFrownIcon',
  'FaceSmileIcon',
  'FilmIcon',
  'FingerPrintIcon',
  'FireIcon',
  'FlagIcon',
  'FolderArrowDownIcon',
  'FolderMinusIcon',
  'FolderOpenIcon',
  'FolderPlusIcon',
  'FolderIcon',
  'ForwardIcon',
  'FunnelIcon',
  'GifIcon',
  'GiftTopIcon',
  'GiftIcon',
  'GlobeAltIcon',
  'GlobeAmericasIcon',
  'GlobeAsiaAustraliaIcon',
  'GlobeEuropeAfricaIcon',
  'HandRaisedIcon',
  'HandThumbDownIcon',
  'HandThumbUpIcon',
  'HashtagIcon',
  'HeartIcon',
  'HomeModernIcon',
  'HomeIcon',
  'IdentificationIcon',
  'InboxArrowDownIcon',
  'InboxStackIcon',
  'InboxIcon',
  'InformationCircleIcon',
  'KeyIcon',
  'LanguageIcon',
  'LifebuoyIcon',
  'LightBulbIcon',
  'LinkIcon',
  'ListBulletIcon',
  'LockClosedIcon',
  'LockOpenIcon',
  'MagnifyingGlassCircleIcon',
  'MagnifyingGlassMinusIcon',
  'MagnifyingGlassPlusIcon',
  'MagnifyingGlassIcon',
  'MapPinIcon',
  'MapIcon',
  'MegaphoneIcon',
  'MicrophoneIcon',
  'MinusCircleIcon',
  'MinusSmallIcon',
  'MinusIcon',
  'MoonIcon',
  'MusicalNoteIcon',
  'NewspaperIcon',
  'NoSymbolIcon',
  'PaintBrushIcon',
  'PaperAirplaneIcon',
  'PaperClipIcon',
  'PauseCircleIcon',
  'PauseIcon',
  'PencilSquareIcon',
  'PencilIcon',
  'PhoneArrowDownLeftIcon',
  'PhoneArrowUpRightIcon',
  'PhoneXMarkIcon',
  'PhoneIcon',
  'PhotoIcon',
  'PlayCircleIcon',
  'PlayPauseIcon',
  'PlayIcon',
  'PlusCircleIcon',
  'PlusSmallIcon',
  'PlusIcon',
  'PowerIcon',
  'PresentationChartBarIcon',
  'PresentationChartLineIcon',
  'PrinterIcon',
  'PuzzlePieceIcon',
  'QrCodeIcon',
  'QuestionMarkCircleIcon',
  'QueueListIcon',
  'RadioIcon',
  'ReceiptPercentIcon',
  'ReceiptRefundIcon',
  'RectangleGroupIcon',
  'RectangleStackIcon',
  'RocketLaunchIcon',
  'RssIcon',
  'ScaleIcon',
  'ScissorsIcon',
  'ServerStackIcon',
  'ServerIcon',
  'ShareIcon',
  'ShieldCheckIcon',
  'ShieldExclamationIcon',
  'ShoppingBagIcon',
  'ShoppingCartIcon',
  'SignalSlashIcon',
  'SignalIcon',
  'SparklesIcon',
  'SpeakerWaveIcon',
  'SpeakerXMarkIcon',
  'Square2StackIcon',
  'Square3Stack3DIcon',
  'Squares2X2Icon',
  'SquaresPlusIcon',
  'StarIcon',
  'StopCircleIcon',
  'StopIcon',
  'SunIcon',
  'SwatchIcon',
  'TableCellsIcon',
  'TagIcon',
  'TicketIcon',
  'TrashIcon',
  'TrophyIcon',
  'TruckIcon',
  'TvIcon',
  'UserCircleIcon',
  'UserGroupIcon',
  'UserMinusIcon',
  'UserPlusIcon',
  'UserIcon',
  'UsersIcon',
  'VariableIcon',
  'VideoCameraSlashIcon',
  'VideoCameraIcon',
  'ViewColumnsIcon',
  'ViewfinderCircleIcon',
  'WalletIcon',
  'WifiIcon',
  'WindowIcon',
  'WrenchScrewdriverIcon',
  'WrenchIcon',
  'XCircleIcon',
  'XMarkIcon'
]

export const EMPTY_STRING = ''

export const COMMON_UPLOAD_POP_UP_TYPE = {
  WRONG_HEADERS: 'WRONG_HEADERS',
  INVALID: 'INVALID',
  VALID: 'VALID',
  NO_RECORDS: 'NO_RECORDS'
} as const

export const COMMON_UPLOAD_POP_UP_LABELS = {
  WRONG_HEADERS: {
    message:
      'Incorrect file headers. The file should have the following column headers:',
    title: 'Error on File Headers',
    buttonLabel: 'Go Back',
    buttonVariant: 'primary'
  },
  INVALID: {
    message:
      'There are no valid records to create a new {{uploadType}}. Review the information and try again.',
    title: 'Upload {{uploadType}}s',
    buttonLabel: 'Go Back',
    buttonVariant: 'primary'
  },
  VALID: {
    message: '',
    title: 'Upload {{uploadType}}s',
    buttonLabel: 'Cancel',
    buttonVariant: 'secondary'
  },
  NO_RECORDS: {
    message:
      'There were no records found in the selected file. Please review and try again',
    title: 'Error',
    buttonLabel: 'Go Back',
    buttonVariant: 'primary'
  }
} as const

export const PATH_TO_SAMPLES = {
  TARGET_GROUP_USERS: '/samples/UploadUsersToManualSegment.csv',
  ACHIEVEMENTS: '/samples/UploadAchievements.csv',
  COMMON_BEHAVIORS: '/samples/UploadBehaviorsGeneral.csv',
  NYPA_BEHAVIORS: '/samples/UploadBehaviorsNYPA.csv',
  POINTS_DISTRIBUTION: '/samples/NewPointsDistribution.csv'
}

export const COMMON_ACTION_TYPE = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  DUPLICATE: 'DUPLICATE'
} as const

export const TIME_INTERVAL = {
  ONE_MINUTE: 60000
}

export const DATE_TIME_CLOCK_FORMAT = 'MM/DD/YYYY - HH:mm'
export const ONE_MINUTE_IN_SECONDS = 60
export const ONE_SECOND_IN_MILLI_SECONDS = 1000
export const WEBSOCKET_ADDRESS_FOR_ADMIN = `${process.env.NEXT_PUBLIC_WS_ADMIN_ADDRESS}`

export const TRANSLATIONS_MARKDOWN_KEY_NAME = [
  'Description',
  'CouponInstructions',
  'ConnectionDescription',
  'WelcomeDescription',
  'NewFeatureDescription',
  'StepDescription',
  'TermsAndConditionsBody',
  'ProviderConnectionScreenDescription',
  'NotificationsScreenDescription'
]

export const TRANSLATIONS_VALIDATION_SECTION = {
  CAMPAIGN: 'Campaign',
  OFFER: 'Offer',
  CATEGORY: 'Category',
  SEGMENT: 'Segment',
  PROVIDER: 'Provider',
  POINTS_DISTRIBUTION: 'PointsDistribution',
  UPDATE_CARD: 'UpdateCard',
  ANNOUNCEMENT: 'Announcement',
  TENANT: 'Tenant',
  TRANSIT_VALIDATION: 'TransitValidation',
  ACTION_BOX: 'ActionBox'
}

export const CLICK = 'click'

export const LOGOUT_BUTTON_LABEL = 'Log out for now'

export const EDIT_SEGMENT_TYPE = {
  INCLUDE: 'Include',
  EXCLUDE: 'Exclude'
}

export const TRACK_EVENT_SECTION_NAME = {
  GENERAL: 'General',
  TENANT: 'Tenant',
  PROVIDERS: 'Providers',
  UPDATES: 'Updates',
  USERS: 'User List',
  SEGMENTS: 'Segments',
  CAMPAIGNS: 'Campaigns',
  CAMPAIGN_CATEGORIES: 'Campaign Categories',
  UPLOAD_ACHIEVEMENTS: 'Upload Achievements',
  UPLOAD_BEHAVIORS: 'Upload Behaviors',
  OFFERS: 'Offers',
  OFFER_CATEGORIES: 'Offer Categories',
  INVOICES: 'Invoices',
  ANNOUNCEMENTS: 'Announcements',
  POINTS_DISTRIBUTION: 'Points Distribution',
  FEATURE_FLAG: 'Feature Flag',
  ADMIN_USERS: 'Admin Users',
  UTILITIES: 'Utilities'
}

export const MFA_TEXT = {
  REGISTRATION: {
    TITLE: 'Authenticate Your Account',
    DESCRIPTION:
      'Scan the QR code below with your authenticator app (e.g., Google Authenticator) to set up two-factor authentication for your account.',
    LABEL: 'I’ve Added it, Next Step'
  },
  VERFICATION: {
    TITLE: 'Enter Your MFA Code',
    DESCRIPTION:
      'Please enter the 6-digit code from your authenticator app to proceed.',
    LABEL: 'Verify'
  }
}
export const CODE = 'Code'
export const LOG_OUT = 'Log out'
export const LOGO_WIDTH = 180

export const HAMBURGER_BUTTON_ID = 'hamburger-button'
export const PREVIEW_IMAGE = {
  WIDTH: 260,
  HEIGHT: 150
}

export const PREVIEW_VARIANT_DRAWER = 'drawer'
export const PREVIEW_VARIANT_DIALOG = 'dialog'

export const VALID_EMAIL_REGEX =
  /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
export const DEFAULT_TEXTFIELD_TYPE = 'text'

export const HOME_PATH = '/overview'
export const DEFAULT_ERROR_MESSAGE = 'An unexpected error has occurred.'

export const FORBIDDEN_ERROR_CODE = 403
export const UNKNOWN_URL = 'Unknown URL'

export const IMAGE_POP_OVER_HEIGHT = 500
export const IMAGE_POP_OVER_WIDTH = 500

export const GEO_MAP_DETAILS = {
  START_LOCATION: {
    TITLE: 'Start Location',
    FILL_COLOR: '#00aa00',
    FILL_OPACITY: 0.4,
    OUTLINE_COLOR: '#007700',
    OUTLINE_WIDTH: 2
  },
  END_LOCATION: {
    TITLE: 'End Location',
    FILL_COLOR: '#cc0000',
    FILL_OPACITY: 0.4,
    OUTLINE_COLOR: '#990000',
    OUTLINE_WIDTH: 2
  }
}

export const GEO_MAP_TYPE = ['Polygon', 'MultiPolygon']

export const NO_VALID_COORDINATES_MESSAGE = 'No Valid Coordinates for Geo Map'
export const SELECT_STYLES = {
  CONTAINER: (provided: CSSObjectWithLabel) => ({
    ...provided,
    width: '200px',
    fontSize: '0.875rem'
  }),
  CONTROL: (provided: CSSObjectWithLabel) => ({
    ...provided,
    backgroundColor: 'white',
    borderColor: 'rgb(229 231 235)',
    minHeight: '40px',
    boxShadow: 'none',
    '&:hover': {
      borderColor: 'rgb(229 231 235)'
    },
    display: 'flex',
    alignItems: 'center',
    borderRadius: '6px',
    cursor: 'pointer'
  }),
  PLACEHOLDER: (provided: CSSObjectWithLabel) => ({
    ...provided,
    color: '#6B7280',
    fontSize: '14px',
    fontWeight: '200'
  }),
  MENU: (provided: CSSObjectWithLabel) => ({
    ...provided,
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgb(229 231 235)',
    zIndex: 9999,
    minWidth: '200px',
    overflow: 'hidden',
    marginTop: '.25em',
    color: '#374152'
  }),
  MENULIST: (provided: CSSObjectWithLabel) => ({
    ...provided,
    padding: '0',
    color: '#374152'
  }),
  CLEAR_INDICATOR: (provided: CSSObjectWithLabel) => ({
    ...provided,
    display: 'inline-block'
  }),
  OPTION: (provided: CSSObjectWithLabel) => ({
    ...provided,
    backgroundColor: 'white',
    color: '#374152',
    '&:hover': {
      backgroundColor: 'rgb(229 231 235)'
    },
    cursor: 'pointer'
  }),
  MULTI_VALUE: (provided: CSSObjectWithLabel) => ({
    ...provided,
    backgroundColor: 'rgb(229 231 235)'
  }),
  MULTI_VALUE_LABEL: (provided: CSSObjectWithLabel) => ({
    ...provided,
    color: 'rgb(55 65 81)'
  }),
  MULTI_VALUE_REMOVE: (provided: CSSObjectWithLabel) => ({
    ...provided,
    color: 'rgb(55 65 81)',
    ':hover': {
      backgroundColor: 'rgb(156 163 175)',
      color: 'white'
    }
  })
}

export const TRUNCATED_COPY_TEXT_MESSAGE = {
  COPIED: 'Copied!',
  FAILED_TO_COPY: 'Failed to copy'
}

export const TRUNCATED_COPY_TEXT_MESSAGE_DISPLAY_TIME_IN_MILLISECONDS = 1000

export const GEO_MAP_STYLE: {
  MAP_SNAPSHOT: React.CSSProperties
} = {
  MAP_SNAPSHOT: {
    width: '100%',
    height: '495px',
    border: '2px solid #0070f3',
    borderRadius: '8px'
  }
}
export const GOOGLE_MAP_DEFAULT_LAT_LNG: LatLng = {
  lat: 38.9072,
  lng: -77.0369
}

export const MAP_SNAPSHOT_BUTTON_LABEL = 'Save Snapshot'

export const MAP_SNAPSHOT_UPLOAD_SUCCESS = 'Snapshot is uploaded'

export const MAP_SNAPSHOT_UPLOADING = 'Uploading...'

export const MAP_SNAPSHOT_ERROR_MESSAGE = 'Failed to take map snapshot'

export const MAP_SNAPSHOT_DEFAULT_FILE_NAME = 'map-snapshot.png'

export const MAP_LOADING_MESSAGE = 'Loading map...'

export const PREVIOUS_STEP_BUTTON_LABEL = 'Previous Step'

export const NO_PRODUCTS_MESSAGE = 'No products available'

export const INITIAL_PAGINATION_DATA = {
  totalCount: 0,
  currentPageStartIndex: 0,
  currentPageEndIndex: 0
}

export const NOT_SUPPORTED = 'Not Supported'

export const CATEGORY_TYPE = {
  ACTION_BOX: 'Action Box Category',
  OFFER: 'Offer Category',
  CAMPAIGN: 'Campaign Category'
}

export const EMERGENY_HIDDEN_WARNING = {
  OFFERS: {
    TITLE: 'Offers HIDDEN by Tenant Configuration',
    DESCRIPTION:
      'All the Offers have been hidden by the Tenant, and are NOT visible on the Rewards App.'
  },
  CAMPAIGNS: {
    TITLE: 'Campaigns HIDDEN by Tenant Configuration',
    DESCRIPTION:
      'All the Campaigns have been hidden by the Tenant. They are NOT visible on the Rewards App, and they will not generate any earnings for the users.'
  }
}

export const ZERO_DOLLAR = '$0.00'

export const ID_NOT_FOUND_ERROR_CODE = -32602
export const ID_NOT_FOUND_ERROR_MESSAGE = 'The provided ID is not found'
